import { Box, InputLabel, Typography, Rating } from "@mui/material";
import React, { useEffect, useState } from "react";
import noImage from "../../assets/no-image.png";

const ServiceCardMansory = ({
  image,
  title,
  price,
  ratings,
  description,
}) => {
  return (
    <>
      <Box
        sx={{
          bgcolor: "#7B408C1a",
          borderRadius: "8px",
          cursor: "pointer",
          overflow: "hidden",
          boxSizing: "border-box",
          transition: "0.2s all linear",
          p: 0,
          width:'100%',
          
          "&:hover": {
            boxShadow:
              "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
          },
        }}
      >
        <Box>
          <img
            srcSet={`${image ? image : noImage}?w=162&auto=format&dpr=2 2x`}
            src={`${image ? image : noImage}?w=162&auto=format`}
            alt={title}
            loading="lazy"
            style={{
              borderBottomLeftRadius: 4,
              borderBottomRightRadius: 4,
              display: "block",
              width: "100%",
            }}
          />

          {/* </Box> */}

          <Box sx={{ pb: 1, p: 1 }}>
            <InputLabel
              variant="caption"
              sx={{ fontSize: "14px", fontWeight: 400, color: "#1a1a1a" }}
            >
              {title}
            </InputLabel>
            <Typography
              variant="caption"
              className="three-line-ellipsis"
              sx={{
                fontSize: "10px",
                fontWeight: 300,
                color: "#1a1a1a",
                mt:0.5
              }}
            >
              {description}
            </Typography>

            <Typography
              sx={{ color: "#333", fontSize: "16px", fontWeight: 500, mt: 0.2 }}
            >
              <span style={{ fontSize: "14px", marginRight: "1px" }}>
                &#36;
              </span>
              {price.toLocaleString()}
            </Typography>
         
           
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ServiceCardMansory;

